/**
 * Where the app trades the bottom tabs for the desktop side menu. Tailwind's `md`
 * (48rem), so the templates' `md:` variants and {@link LayoutService.isDesktop}
 * switch at the same width.
 */
export const DESKTOP_MEDIA_QUERY = '(min-width: 48rem)';

/**
 * Route data flag for pages whose top section joins the app bar on desktop, so the
 * bar squares its bottom corners instead of reading as a separate card.
 */
export const HEADER_ATTACHED_ROUTE_DATA = 'headerAttached';
